module.exports = __webpack_public_path__ + "static/media/kehubaifangbiao.d3f597fc.png";